import axios from '@axios'

export const state = {
  cars: [],
  car: {},
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allCarWholesales: (state) => state.cars,
  currentCar: (state) => state.car,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_CAR_WHOLESALE: (state, resp) => {
    if (!resp) return null
    state.car = { ...resp }
  },
  GET_CAR_WHOLESALES: (state, resp) => {
    if (!resp) return null
    state.cars = resp.cars
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
}

export const actions = {
  async getCarWholesales({ commit }, params = {}) {
    await axios
      .get(`/api/cars/wholesales`, {
        params: params,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_CAR_WHOLESALES', data)
        }
      })
      .catch((err) => {
        let data = err.response.status === 404 ? { cars: [] } : null
        commit('GET_CAR_WHOLESALES', data)
      })
  },
  async getShareVehicle({ commit }, VIN = '') {
    return axios.get(`/api/wholesale/share/${VIN}`, {})
  },
}
